export default __webpack_public_path__ + "static/media/pictogramBeaconStandardVehicle64.17cdc94b.svg";